export function isPdf(mimeType: string) {
  return mimeType === 'application/pdf';
}
